import {IntermediatePart} from "../../intermediatePart";

export default class BottomCabinetShadow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bottom_cabinet_shadow';
    this.partName = 'Bottom Cabinet Shadow';
    this.visible = false;
    this.layerPriority = 7;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BottomCabinetShadow());
  }

  setLayers(layout) {

    const bottomCabinet = this.getParent().bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    this.activeFeature = filteredFeatures[0];
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Cabinet.BottomCabinetShadow;
    }
  }
}